import {
  ActionIcon,
  Box,
  Chip,
  SegmentedControl,
  Container,
  Center,
  Flex,
  Group,
  LoadingOverlay,
  Select,
  Tabs,
  Text,
  TextInput,
  Title,
  rem,
  Paper,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import {
  IconBell,
  IconPlus,
  IconSearch,
  IconUser,
  IconX,
  IconClock,
  IconCopy,
  IconUserFilled,
  IconAlertOctagon,
  IconCircleCheck,
  IconXboxX,
  IconCalendarMonth,
  IconFolder,
  IconBan,
  IconAlertCircle
} from "@tabler/icons-react";
import axios from "axios";
import { useEffect, useLayoutEffect, useState } from "react";
import { API_URL } from "../../services/url";
import checkUserId from "../../utils/checkuserid";
import { CarSeaterList, SortByList } from "../CreateJob/constants";
import { JobInfoProps } from "../CreateJob/type";
import AllJobs from "./alljobs";
import MyJobs from "./myjobs";
import classes from "./tab.module.css";

const Home = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  const [jobList, setJobList] = useState<JobInfoProps[]>([]);

  const [myJobList, setMyJobList] = useState<JobInfoProps[]>([]);

  const [chips, setChips] = useState("all");

  const [activeTab, setActiveTab] = useState("alljobs");

  const [invitedJobList, setInvitedJobList] = useState<JobInfoProps[]>([]);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [sortby, setSortby] = useState<string | null>("pickup_at#asc");

  const [requestedlist, setRequestedlist] = useState<string[]>();

  // const [type, setType] = useState<string | null>("pickup_at");

  const [serviceBy, setServiceby] = useState<string | null>("");

  const [invite_id, setInvite_id] = useState([])

  const driverId = localStorage.getItem("userId");

  useLayoutEffect(() => {
    checkUserId();
  }, []);

  const fetchJob = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}job-listings/`);
      console.log("🚀 ~ fetchJob ~ response:", response);
      setJobList(response.data);
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed to fetch job details",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchJobinvite = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}job-invite/`);
      const id = response.data.map((Jobs: { job: any; }) => Jobs.job)
      setInvite_id(id)
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed to fetch job invite details",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchMyJob = async () => {
    try {
      if (driverId === null) return;
      setLoading(true);
      const response = await axios.get(
        `${API_URL}driver/${driverId}/posted-jobs/`
      );
      if (response.data)
        if (response.data.jobs) setMyJobList(response.data.jobs);
      console.log("🚀 ~ fetchMyJob ~ response:", response);
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed to fetch my job details",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchInvitedJob = async () => {
    try {
      if (driverId === null) return;
      setLoading(true);
      const response = await axios.get(
        `${API_URL}driver/${driverId}/invite-jobs/`
      );
      if (response.data)
        if (response.data.job_invites)
          setInvitedJobList(response.data.job_invites.filter((job: JobInfoProps) => job.status === "pending"));
      console.log("🚀 ~ fetchInvitedJob ~ response:", response);
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed to fetch invited job details",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJob();
    fetchMyJob();
    fetchJobinvite();
    fetchInvitedJob();
  }, []);

  const filterJob = async () => {
    try {
      setLoading(true);
      let content = sortby?.split("#") || ["", ""];
      console.log("🚀 ~ filterJob ~ content:", content);
      const response = await axios.get(
        `${API_URL}job-listings/?services_required=${serviceBy}&search=${search}&sort_by=${content[0]}&type=${content[1]}`
      );
      console.log("🚀 ~ fposetchJob ~ response:", response.data);
      setJobList(response.data);
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed to fetch job details",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    filterJob();
  }, [search, sortby, serviceBy]);

  // Utility function to filter jobs based on the presence of status in chips
  const filterJobsByStatus = (jobs: JobInfoProps[], chips: string[]) => {
    if (chips.includes("upcoming_jobs")) {
      const currentTime = new Date();
      // Filter and sort upcoming jobs by pickup time
      return jobs
        .filter((job) => {
          const pickupTime = new Date(job.pickup_at);
          // Show job as upcoming if pickup time is within the next hour
          return (
            job.status !== "cancelled" &&
            (job.status === "pending" || job.status === "assigned") &&
            pickupTime > currentTime // pickup time is in the future
          );
        })
        .sort((a, b) => new Date(a.pickup_at).getTime() - new Date(b.pickup_at).getTime());
    }
    if (chips.includes("all")) {
      return jobs;
    }
    // For other cases, filter based on the chips array
    return jobs.filter((job) => chips.length === 0 || chips.includes(job.status));
  };


  // Use the utility function to filter both myJobList and invitedJobList
  const filteredMyJob = [
    ...filterJobsByStatus(myJobList, chips ? [chips] : []),
    ...filterJobsByStatus(invitedJobList, chips ? [chips] : []),
  ];

  const handleChipClick = (event: React.MouseEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === chips) {
      setChips('all');
    }
  };

  // request list

  const fetchlist = async () => {
    try {
      const listres = await axios.get(
        `${API_URL}job-request/?driver=${driverId}`
      );
      const jobIds = listres.data.map((item: any) => item.job);
      setRequestedlist(jobIds);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchlist();
  }, []);

  const handleRefresh = () => {
    fetchJob()
    fetchMyJob()
  }

  return (
    <Container
      size={isMobile ? "xs" : "sm"}
      px={isMobile ? "xs" : "sm"}
      py={isMobile ? "md" : "xl"}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "self-start",
        textAlign: "left",
      }}
    >
      <LoadingOverlay visible={loading} />

      <Paper shadow="sm" p="lg" radius="md" withBorder w="100%">
        <Group justify="space-between">
          <Group>
            <img src={'/landingimg.png'} alt="Kabbie Logo" style={{ height: rem(32) }} />
            <Title order={3}>Kabbie</Title>
          </Group>
          <Group>
            <ActionIcon
              variant="gradient"
              gradient={{ from: 'dark', to: 'gray', deg: 145 }}
              size="lg"
              radius="md"
              aria-label="Create Job"
              onClick={() => (window.location.href = "/createjob")}
            >
              <IconPlus />
            </ActionIcon>
            <ActionIcon
              variant="light"
              size="lg"
              radius="md"
              color="gray"
              aria-label="Notifications"
              onClick={() => (window.location.href = "/notifications")}
            >
              <IconBell />
            </ActionIcon>
            <ActionIcon
              variant="light"
              size="lg"
              radius="md"
              color="gray"
              aria-label="Profile"
              onClick={() => (window.location.href = "/profile")}
            >
              <IconUser />
            </ActionIcon>
          </Group>
        </Group>
      </Paper>

      <Box w={"100%"} mt={"md"}>
        <SegmentedControl
          fullWidth
          color="dark"
          radius="md"
          size="lg"
          value={activeTab}
          onChange={setActiveTab}
          my="md"
          data={[
            { label: "All Jobs", value: "alljobs" },
            { label: "My Jobs", value: "myjobs" },
          ]}
        />
        {activeTab === "alljobs" && (
          <Box>
            <Paper shadow="sm" p="lg" radius="md" withBorder>
              <TextInput
                radius="md"
                value={search}
                placeholder="Search Location, Booking ID, Suburb"
                onChange={(event) => setSearch(event.currentTarget.value)}
                w={"100%"}
                rightSectionPointerEvents="visible"
                rightSection={
                  search === "" ? (
                    <IconSearch style={{ width: rem(20), height: rem(20) }} />
                  ) : (
                    <IconX
                      style={{ width: rem(20), height: rem(20) }}
                      onClick={() => setSearch("")}
                    />
                  )
                }
                labelProps={{ style: { alignSelf: "flex-start" } }}
              />

              <Flex
                justify={"space-between"}
                align={"center"}
                w={"100%"}
                mt="md"
              >
                <Select
                  radius="md"
                  w={"48%"}
                  placeholder="Service Required"
                  data={CarSeaterList}
                  value={serviceBy}
                  clearable
                  onClear={() => setServiceby("")}
                  onChange={(value) => setServiceby(value)}
                />
                <Select
                  radius="md"
                  w={"48%"}
                  placeholder="Sort By"
                  data={SortByList}
                  value={sortby}
                  clearable
                  onClear={() => setSortby("")}
                  onChange={(value) => setSortby(value)}
                />
              </Flex>
            </Paper>

            {jobList.length === 0 ? (
              <Text size="md" mt="lg" ta="center">
                No Jobs available
              </Text>
            ) : (
              (search !== "" || (sortby !== null && sortby !== "")) && (
                <Text size="xs" mt={"xs"}>
                  {`Showing ${jobList.length} Results`}{" "}
                </Text>
              )
            )}

            {jobList.map((job) => (
              <AllJobs
                job={job}
                driverId={driverId}
                key={job.id}
                requestlist={requestedlist}
                reFresh={handleRefresh}
              />
            ))}
          </Box>
        )}
        {activeTab === "myjobs" && (
          <Box>
            <SegmentedControl
              fullWidth
              color="dark"
              radius="md"
              value={chips}
              onChange={setChips}
              my="lg"
              data={[
                {
                  value: "all",
                  label: (
                    <Center>
                      <IconFolder style={{ width: rem(16), height: rem(16) }} />
                      <Box ml="sm">All</Box>
                    </Center>
                  ),
                },
                {
                  value: "upcoming_jobs",
                  label: (
                    <Center>
                      <IconCalendarMonth style={{ width: rem(16), height: rem(16) }} />
                      <Box ml="sm">Upcoming</Box>
                    </Center>
                  ),
                },
                {
                  value: "uncovered",
                  label: (
                    <Center>
                      <IconAlertCircle style={{ width: rem(16), height: rem(16) }} />
                      <Box ml="sm">Uncovered</Box>
                    </Center>
                  ),
                },
                {
                  value: "cancelled",
                  label: (
                    <Center>
                      <IconBan style={{ width: rem(16), height: rem(16) }} />
                      <Box ml="sm">Cancelled</Box>
                    </Center>
                  ),
                },
              ]}
            />

            {filteredMyJob.length === 0 ? (
              <Text size="md" mt="lg" ta="center">
                No Jobs available
              </Text>
            ) : (
              (search !== "" || (sortby !== null && sortby !== "")) && (
                <Text size="xs">{`Showing ${filteredMyJob.length} Results`}</Text>
              )
            )}

            {filteredMyJob.map((job) => (
              <MyJobs
                job={job}
                driverId={driverId}
                key={job.id}
                id={invite_id}
              />
            ))}
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Home;
